var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "animate-css",
          rawName: "v-animate-css",
          value: { classes: "slideInRight", delay: 0, duration: 500 },
          expression: "{ classes: 'slideInRight', delay: 0, duration: 500 }",
        },
      ],
      staticClass: "automation-block-modal",
      attrs: { "block-type": _vm.block.type },
    },
    [
      _c("div", { staticClass: "main" }, [
        _c("div", { staticClass: "header" }, [
          _c("div", { staticClass: "left" }, [
            _c(
              "div",
              {
                staticClass:
                  "d-flex align-items-center align-content-center justify-content-start pb-2",
              },
              [
                _c("BlockIconPreview", {
                  staticClass: "mr-2",
                  staticStyle: { color: "#919ead" },
                  attrs: { "block-type": _vm.block.type },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "blockTypeText" }, [
                  _vm._v(_vm._s(_vm.$t("chatbotv2." + _vm.block.type))),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "name" },
              [
                _c("BlockTitle", {
                  attrs: {
                    name: _vm.block.name,
                    block: _vm.block,
                    "is-save": _vm.isSaveProp,
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "right" }, [
            _c(
              "button",
              {
                staticClass: "chatbot-btn",
                on: {
                  click: function ($event) {
                    return _vm.handleClose()
                  },
                },
              },
              [_c("md-icon", [_vm._v("close")])],
              1
            ),
            _vm._v(" "),
            !_vm.previewMode
              ? _c(
                  "button",
                  {
                    staticClass: "chatbot-btn",
                    on: {
                      click: function ($event) {
                        return _vm.updatePayload()
                      },
                    },
                  },
                  [_c("md-icon", [_vm._v("save")])],
                  1
                )
              : _vm._e(),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "body" }, [
          _vm.previewMode
            ? _c(
                "span",
                { staticClass: "bg-primary text-light p-3 w-100 d-block" },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("chatbotv2.previewModeCaution")) +
                      "\n            "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.payload
            ? _c("div", { staticClass: "payload-wrapper" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("chatbotv2.addPayload")) +
                    "\n            "
                ),
              ])
            : _c(
                "div",
                { staticClass: "payload-wrapper" },
                [
                  _vm.block.type === _vm.AUTOMATION_BLOCK_TYPES.FILTER
                    ? [
                        _c("FilterBlock", {
                          attrs: { automation: _vm.automation },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type === _vm.AUTOMATION_BLOCK_TYPES.WEBHOOK
                    ? [
                        _c("Webhook", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type ===
                  _vm.AUTOMATION_BLOCK_TYPES.SEND_JSON_RESPONSE
                    ? [
                        _c("SendJsonResponse", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type === _vm.AUTOMATION_BLOCK_TYPES.SLEEP
                    ? [
                        _c("Sleep", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type === _vm.AUTOMATION_BLOCK_TYPES.ASK_AI
                    ? [
                        _c("AskAI", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type ===
                  _vm.AUTOMATION_BLOCK_TYPES.OPENROUTER_RESPONSE
                    ? [
                        _c("ProviderResponse", {
                          attrs: { provider: "openrouter" },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type === _vm.AUTOMATION_BLOCK_TYPES.OPENAI_RESPONSE
                    ? [
                        _c("ProviderResponse", {
                          attrs: { provider: "openai" },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type ===
                  _vm.AUTOMATION_BLOCK_TYPES.GOOGLE_AI_RESPONSE
                    ? [
                        _c("ProviderResponse", {
                          attrs: { provider: "google" },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type ===
                  _vm.AUTOMATION_BLOCK_TYPES.ANTHROPIC_RESPONSE
                    ? [
                        _c("ProviderResponse", {
                          attrs: { provider: "anthropic" },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type === _vm.AUTOMATION_BLOCK_TYPES.MISTRAL_RESPONSE
                    ? [
                        _c("ProviderResponse", {
                          attrs: { provider: "mistral" },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type === _vm.AUTOMATION_BLOCK_TYPES.AZURE_RESPONSE
                    ? [
                        _c("ProviderResponse", {
                          attrs: { provider: "azure" },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type === _vm.AUTOMATION_BLOCK_TYPES.BEDROCK_RESPONSE
                    ? [
                        _c("ProviderResponse", {
                          attrs: { provider: "bedrock" },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type === _vm.AUTOMATION_BLOCK_TYPES.COHERE_RESPONSE
                    ? [
                        _c("ProviderResponse", {
                          attrs: { provider: "cohere" },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type === _vm.AUTOMATION_BLOCK_TYPES.XAI_RESPONSE
                    ? [
                        _c("ProviderResponse", {
                          attrs: { provider: "xai" },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type ===
                  _vm.AUTOMATION_BLOCK_TYPES.DEEPINFRA_RESPONSE
                    ? [
                        _c("ProviderResponse", {
                          attrs: { provider: "deepinfra" },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type ===
                  _vm.AUTOMATION_BLOCK_TYPES.TOGETHER_RESPONSE
                    ? [
                        _c("ProviderResponse", {
                          attrs: { provider: "together" },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type ===
                  _vm.AUTOMATION_BLOCK_TYPES.FIREWORKS_RESPONSE
                    ? [
                        _c("ProviderResponse", {
                          attrs: { provider: "fireworks" },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type ===
                  _vm.AUTOMATION_BLOCK_TYPES.SILICONFLOW_RESPONSE
                    ? [
                        _c("ProviderResponse", {
                          attrs: { provider: "siliconflow" },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type ===
                  _vm.AUTOMATION_BLOCK_TYPES.PARASAIL_RESPONSE
                    ? [
                        _c("ProviderResponse", {
                          attrs: { provider: "parasail" },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type === _vm.AUTOMATION_BLOCK_TYPES.NEBIUS_RESPONSE
                    ? [
                        _c("ProviderResponse", {
                          attrs: { provider: "nebius" },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type === _vm.AUTOMATION_BLOCK_TYPES.ALIBABA_RESPONSE
                    ? [
                        _c("ProviderResponse", {
                          attrs: { provider: "alibaba" },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type === _vm.AUTOMATION_BLOCK_TYPES.XIAOMI_RESPONSE
                    ? [
                        _c("ProviderResponse", {
                          attrs: { provider: "xiaomi" },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type ===
                  _vm.AUTOMATION_BLOCK_TYPES.SAMBANOVA_RESPONSE
                    ? [
                        _c("ProviderResponse", {
                          attrs: { provider: "sambanova" },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type ===
                  _vm.AUTOMATION_BLOCK_TYPES.MOONSHOT_RESPONSE
                    ? [
                        _c("ProviderResponse", {
                          attrs: { provider: "moonshot" },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type === _vm.AUTOMATION_BLOCK_TYPES.MINIMAX_RESPONSE
                    ? [
                        _c("ProviderResponse", {
                          attrs: { provider: "minimax" },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type === _vm.AUTOMATION_BLOCK_TYPES.NVIDIA_RESPONSE
                    ? [
                        _c("ProviderResponse", {
                          attrs: { provider: "nvidia" },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type === _vm.AUTOMATION_BLOCK_TYPES.CREATE_CONTACT
                    ? [
                        _c("CreateContact", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type === _vm.AUTOMATION_BLOCK_TYPES.UPDATE_CONTACT
                    ? [
                        _c("UpdateContact", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type ===
                  _vm.AUTOMATION_BLOCK_TYPES.TERMINATE_AUTOMATION
                    ? [
                        _c("TerminateAutomation", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type ===
                  _vm.AUTOMATION_BLOCK_TYPES.SEND_WP_BUSINESS_MESSAGE
                    ? [
                        _c("SendWhatsappTemplateMessage", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type === _vm.AUTOMATION_BLOCK_TYPES.LOOP
                    ? [
                        _c("Loop", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type === _vm.AUTOMATION_BLOCK_TYPES.FIND_CONTACTS
                    ? [
                        _c("FindContacts", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type === _vm.AUTOMATION_BLOCK_TYPES.FIND_CONTACT
                    ? [
                        _c("FindContact", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type === _vm.AUTOMATION_BLOCK_TYPES.STRING_FORMAT
                    ? [
                        _c("StringFormatter", {
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type === _vm.AUTOMATION_BLOCK_TYPES.NUMBER_FORMAT
                    ? [
                        _c("NumberFormatterChain", {
                          attrs: { "block-id": _vm.block.id },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type === _vm.AUTOMATION_BLOCK_TYPES.DATE_FORMAT
                    ? [
                        _c("DateFormatChain", {
                          attrs: { "block-id": _vm.block.id },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type === _vm.AUTOMATION_BLOCK_TYPES.RECORDS_FROM_CSV
                    ? [
                        _c("RecordsFromCSV", {
                          attrs: { "block-id": _vm.block.id },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type === _vm.AUTOMATION_BLOCK_TYPES.WAIT_FOR
                    ? [
                        _c("WaitFor", {
                          attrs: { "block-id": _vm.block.id },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type === _vm.AUTOMATION_BLOCK_TYPES.SEND_MAIL
                    ? [
                        _c("SendMail", {
                          attrs: { "block-id": _vm.block.id },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type === _vm.AUTOMATION_BLOCK_TYPES.CREATE_TICKET
                    ? [
                        _c("CreateTicket", {
                          attrs: { "block-id": _vm.block.id },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type ===
                  _vm.AUTOMATION_BLOCK_TYPES.TABLE_UPDATE_RECORD
                    ? [
                        _c("UpdateRecord", {
                          attrs: { "block-id": _vm.block.id },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type ===
                  _vm.AUTOMATION_BLOCK_TYPES.TABLE_CREATE_RECORD
                    ? [
                        _c("CreateRecord", {
                          attrs: { "block-id": _vm.block.id },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type ===
                  _vm.AUTOMATION_BLOCK_TYPES.TABLE_FIND_RECORD
                    ? [
                        _c("FindRecord", {
                          attrs: { "block-id": _vm.block.id },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type ===
                  _vm.AUTOMATION_BLOCK_TYPES.TABLE_FIND_RECORDS
                    ? [
                        _c("FindRecords", {
                          attrs: { "block-id": _vm.block.id },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type ===
                  _vm.AUTOMATION_BLOCK_TYPES.TABLE_DELETE_RECORD
                    ? [
                        _c("DeleteRecord", {
                          attrs: { "block-id": _vm.block.id },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type ===
                  _vm.AUTOMATION_BLOCK_TYPES.ZOHO_FIND_RECORDS_BY_PHONE
                    ? [
                        _c("ZohoFindRecordsByPhone", {
                          attrs: { "block-id": _vm.block.id },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type ===
                  _vm.AUTOMATION_BLOCK_TYPES.ZOHO_ADD_ATTACHMENT_TO_RECORD
                    ? [
                        _c("ZohoAddAttachmentToRecord", {
                          attrs: { "block-id": _vm.block.id },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type ===
                  _vm.AUTOMATION_BLOCK_TYPES.ZOHO_UPLOAD_IMAGE_TO_RECORD_FIELD
                    ? [
                        _c("ZohoUploadImageToField", {
                          attrs: { "block-id": _vm.block.id },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type ===
                  _vm.AUTOMATION_BLOCK_TYPES.ZOHO_CREATE_RECORD
                    ? [
                        _c("ZohoCreateRecord", {
                          attrs: { "block-id": _vm.block.id },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type ===
                  _vm.AUTOMATION_BLOCK_TYPES.GET_SUPSIS_RECORD_BY_ID
                    ? [
                        _c("GetSupsisRecordById", {
                          attrs: { "block-id": _vm.block.id },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type === _vm.AUTOMATION_BLOCK_TYPES.SHOW_WIDGET
                    ? [
                        _c("ShowWidget", {
                          attrs: { "block-id": _vm.block.id },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type === _vm.AUTOMATION_BLOCK_TYPES.GO_TO_STEP
                    ? [
                        _c("GotoStep", {
                          attrs: {
                            "flatted-diagram": _vm.flattedDiagram,
                            isGotoStep:
                              _vm.block.type ===
                              _vm.AUTOMATION_BLOCK_TYPES.GO_TO_STEP,
                          },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type === _vm.AUTOMATION_BLOCK_TYPES.TICKET_UPDATE
                    ? [
                        _c("TicketUpdate", {
                          attrs: { "block-id": _vm.block.id },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type === _vm.AUTOMATION_BLOCK_TYPES.UPDATE_TASK
                    ? [
                        _c("UpdateTask", {
                          attrs: { "block-id": _vm.block.id },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type === _vm.AUTOMATION_BLOCK_TYPES.CREATE_TASK
                    ? [
                        _c("CreateTask", {
                          attrs: { "block-id": _vm.block.id },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type === _vm.AUTOMATION_BLOCK_TYPES.ASSIGN_OWNER
                    ? [
                        _c("AssignOwner", {
                          attrs: { "block-id": _vm.block.id },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type === _vm.AUTOMATION_BLOCK_TYPES.SEND_SMS
                    ? [
                        _c("SendSMS", {
                          attrs: { "block-id": _vm.block.id },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type === _vm.AUTOMATION_BLOCK_TYPES.AI_CALL
                    ? [
                        _c("AICall", {
                          attrs: { "block-id": _vm.block.id },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type === _vm.AUTOMATION_BLOCK_TYPES.RUN_JAVASCRIPT
                    ? [
                        _c("RunJavaScript", {
                          attrs: {
                            "block-id": _vm.block.id,
                            automation: _vm.automation,
                          },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type ===
                  _vm.AUTOMATION_BLOCK_TYPES.META_SEND_CAPI_EVENT
                    ? [
                        _c("MetaSendCapiEvent", {
                          attrs: { "block-id": _vm.block.id },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type === _vm.AUTOMATION_BLOCK_TYPES.CACHE_WRITE
                    ? [
                        _c("CacheWrite", {
                          attrs: { "block-id": _vm.block.id },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type === _vm.AUTOMATION_BLOCK_TYPES.CACHE_READ
                    ? [
                        _c("CacheRead", {
                          attrs: { "block-id": _vm.block.id },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type === _vm.AUTOMATION_BLOCK_TYPES.CACHE_EXTEND
                    ? [
                        _c("CacheExtend", {
                          attrs: { "block-id": _vm.block.id },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type === _vm.AUTOMATION_BLOCK_TYPES.CACHE_DELETE
                    ? [
                        _c("CacheDelete", {
                          attrs: { "block-id": _vm.block.id },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type ===
                  _vm.AUTOMATION_BLOCK_TYPES.YOUTUBE_REPLY_COMMENT
                    ? [
                        _c("YouTubeReplyComment", {
                          attrs: { "block-id": _vm.block.id },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type ===
                  _vm.AUTOMATION_BLOCK_TYPES.YOUTUBE_UPDATE_COMMENT_STATUS
                    ? [
                        _c("YouTubeUpdateCommentStatus", {
                          attrs: { "block-id": _vm.block.id },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type ===
                  _vm.AUTOMATION_BLOCK_TYPES.YOUTUBE_SET_MODERATION_STATUS
                    ? [
                        _c("YouTubeSetModerationStatus", {
                          attrs: { "block-id": _vm.block.id },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type ===
                  _vm.AUTOMATION_BLOCK_TYPES.GOOGLE_BUSINESS_REPLY_REVIEW
                    ? [
                        _c("GoogleBusinessReplyReview", {
                          attrs: { "block-id": _vm.block.id },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type ===
                  _vm.AUTOMATION_BLOCK_TYPES
                    .GOOGLE_BUSINESS_UPDATE_REVIEW_STATUS
                    ? [
                        _c("GoogleBusinessUpdateReviewStatus", {
                          attrs: { "block-id": _vm.block.id },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type ===
                  _vm.AUTOMATION_BLOCK_TYPES.GOOGLE_PLAY_REPLY_REVIEW
                    ? [
                        _c("GooglePlayReplyReview", {
                          attrs: { "block-id": _vm.block.id },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type ===
                  _vm.AUTOMATION_BLOCK_TYPES.GOOGLE_PLAY_UPDATE_REVIEW_STATUS
                    ? [
                        _c("GooglePlayUpdateReviewStatus", {
                          attrs: { "block-id": _vm.block.id },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type ===
                  _vm.AUTOMATION_BLOCK_TYPES.APP_STORE_REPLY_REVIEW
                    ? [
                        _c("AppStoreReplyReview", {
                          attrs: { "block-id": _vm.block.id },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type ===
                  _vm.AUTOMATION_BLOCK_TYPES.APP_STORE_UPDATE_REVIEW_STATUS
                    ? [
                        _c("AppStoreUpdateReviewStatus", {
                          attrs: { "block-id": _vm.block.id },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type ===
                  _vm.AUTOMATION_BLOCK_TYPES.APP_STORE_DELETE_REVIEW_RESPONSE
                    ? [
                        _c("AppStoreDeleteReviewResponse", {
                          attrs: { "block-id": _vm.block.id },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type ===
                  _vm.AUTOMATION_BLOCK_TYPES.GOOGLE_DRIVE_UPLOAD_FILE
                    ? [
                        _c("GoogleDriveUploadFile", {
                          attrs: { "block-id": _vm.block.id },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type ===
                  _vm.AUTOMATION_BLOCK_TYPES.GOOGLE_DRIVE_DOWNLOAD_FILE
                    ? [
                        _c("GoogleDriveDownloadFile", {
                          attrs: { "block-id": _vm.block.id },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type ===
                  _vm.AUTOMATION_BLOCK_TYPES.GOOGLE_DRIVE_GET_FILE_INFO
                    ? [
                        _c("GoogleDriveGetFileInfo", {
                          attrs: { "block-id": _vm.block.id },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.block.type ===
                  _vm.AUTOMATION_BLOCK_TYPES.GOOGLE_DRIVE_DELETE_FILE
                    ? [
                        _c("GoogleDriveDeleteFile", {
                          attrs: { "block-id": _vm.block.id },
                          model: {
                            value: _vm.payload,
                            callback: function ($$v) {
                              _vm.payload = $$v
                            },
                            expression: "payload",
                          },
                        }),
                      ]
                    : _vm._e(),
                ],
                2
              ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }